import { gql } from "@apollo/client";

const GET_CLIENT_MANUAL_RULES = gql`
  query getClientManualRules($identifier: String!) {
    client(clientIdentifier: $identifier) {
      id
      riskScore {
        manualRules {
          isEditable
          ruleType
          selectableValues {
            title
            value
          }
        }
      }
    }
  }
`;

export default GET_CLIENT_MANUAL_RULES;
